import React from 'react';
import {
    Button, Col, Row, Breadcrumb, Input, Spin, Form,
    Typography, Divider, Radio
} from 'antd';
import Icon from '@ant-design/icons';
import {
    cardLayout,
    modaisDeConfig,
    colLisTabelaConfigs,
    modalAddModuloInputs,
    forceUpdateGrid,
    mainFormGrid,
    secondFormGrid
} from './GridStyle';

import { FaCogs } from 'react-icons/fa';
import InputAppChanges from '../../../../../components/InputAppChanges';
import PreVisualizacaoAlteracoes from '../components/PreVisualizacaoAlteracoes';
import useFormVersaoApp from './useFormVersaoApp';


const IconCogs = (props: any) => <Icon {...props} component={FaCogs} ></Icon>

const { Title } = Typography;


const FormVersaoApp: React.FC = () => {

    const {
        onClickVoltarConfigOfSystem,
        onClickVoltarListarVersaoApp,
        initialValueEditId,
        loadingFormAdd,
        formRef,
        onChangeInputNumberNumero,
        onChangeInputNumberDiasParaAtualizar,
        onChangeInputNumberBuildIos,
        onChangeInputNumberBuildAndroid,
        oldAlteracoes,
        handleChangeAlteracoes,
        alteracoes,
        history,
        clickSubmitVersionApp,
        valorNumero
    } = useFormVersaoApp();

    return (
        <>
            <Row>
                <Col {...cardLayout}>
                    <Title level={3}><IconCogs style={{ fontSize: 35 }} /> Configurações do Sistema</Title>
                    <Breadcrumb>
                        <Breadcrumb.Item><a onClick={onClickVoltarConfigOfSystem}>Configurações do Sistema</a></Breadcrumb.Item>
                        <Breadcrumb.Item><a onClick={onClickVoltarListarVersaoApp}>Versão App</a></Breadcrumb.Item>
                        <Breadcrumb.Item>{initialValueEditId ? 'Editar' : 'Criar'}</Breadcrumb.Item>
                    </Breadcrumb>
                    <Divider />
                </Col>
            </Row>
            <Row>
                <Col {...colLisTabelaConfigs}>
                    <Spin spinning={loadingFormAdd}>
                        <Form
                            ref={formRef}
                            name="formModalAddRotas"
                            layout="vertical"
                            initialValues={{
                                remember: true,
                            }}
                            onFinishFailed={() => { }}
                        >
                            <Row gutter={24}>
                                <Col {...mainFormGrid}>
                                    <Row>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Preencha a Numero!",
                                                    }
                                                ]}
                                                name="numero"
                                                label="Numero"
                                                style={{ margin: 5 }}
                                            >
                                                <Input
                                                    onChange={onChangeInputNumberNumero}
                                                    placeholder="Ex: 1.1" />
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Preencha a campo!",
                                                    }
                                                ]}
                                                name="dias_para_atualizar"
                                                label="Dias para atualizar"
                                                style={{ margin: 5 }}
                                            >
                                                <Input
                                                    onChange={onChangeInputNumberDiasParaAtualizar}
                                                    placeholder="120"
                                                    maxLength={3}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: "Preencha o build ios!",
                                                    }
                                                ]}
                                                name="build_ios"
                                                label="Build IOS"
                                                style={{ margin: 5 }}
                                            >
                                                <Input
                                                    onChange={onChangeInputNumberBuildIos}
                                                    placeholder="Ex: 1.1" />
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: "Preencha o build android!",
                                                    }
                                                ]}
                                                name="build_android"
                                                label="Build Android"
                                                style={{ margin: 5 }}
                                            >
                                                <Input
                                                    onChange={onChangeInputNumberBuildAndroid}
                                                    placeholder="Ex: 1.1"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col {...forceUpdateGrid}>
                                            <Form.Item
                                                initialValue={true}
                                                name="force"
                                                label="Forçar atualizar o app"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Selecione o forçar!",
                                                    }
                                                ]}
                                                style={{ marginTop: 5, marginBottom: 8 }}
                                            >
                                                <Radio.Group>
                                                    <Radio.Button value={true}>Sim</Radio.Button>
                                                    <Radio.Button value={false}>Não</Radio.Button>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Col>
                                        {oldAlteracoes && <Col {...modaisDeConfig}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: "Por favor comente as alterações!",
                                                    }
                                                ]}
                                                name="alteracoes"
                                                label="Alterações"
                                            >
                                                <Input.TextArea style={{ maxHeight: 200, height: 100 }} />
                                            </Form.Item>
                                        </Col>}
                                        <Col {...modaisDeConfig}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: "Por favor comente as alterações!",
                                                    }
                                                ]}
                                                name="alteracoes_json"
                                                label="Alterações"
                                            >
                                                <InputAppChanges onChange={handleChangeAlteracoes} value={alteracoes} name="alteracoes_json" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Button key="back" disabled={loadingFormAdd} onClick={() => history.goBack()}>
                                                Cancelar
                                            </Button>
                                            <Button key="submit" type="primary" loading={loadingFormAdd} onClick={clickSubmitVersionApp}>
                                                Salvar
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col {...secondFormGrid}>
                                    {alteracoes && <PreVisualizacaoAlteracoes versao={valorNumero} alteracoes={alteracoes} />}
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Col>
            </Row>
        </>
    );
}

export default FormVersaoApp;
